import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-pages" }

import { ref, computed, watch, nextTick } from 'vue';
import DrawerLayer from '@distancify-storefront/ui-drawer-layer';
import MyPagesMenu from './MyPagesMenu.vue';
import MyPagesOrders from './MyPagesOrders.vue';
import MyPagesRentals from './MyPagesRentals.vue';
import PersonProfile from './PersonProfile.vue';
import OrganizationProfile from './OrganizationProfile.vue';
import Installer from './Installers/Installer.vue';
import AddressRemove from './components/AddressRemove.vue';

import useUser from '@/composables/useUser';
import useContext from '@/composables/useContext';
import useEventListener from '@/composables/useEventListener';

import { MY_PAGES } from '@/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyPages',
  setup(__props) {

const {
  page,
  route,
  navigateToLoginPage,
  navigate,
  settings,
  resolveLink,
  channel,
} = useContext();
const { user } = useUser();

const { useEmitterEventListener } = useEventListener();

const isMyPagesOpen = ref(false);
const selectedMenuItem = ref('');

const reviewerPageUrl = computed(() => {
  const url = resolveLink(() => settings.value?.reviewer)?.url || '';
  return url ? '/' + url + '?reviewer_id=' + user.value?.reviewerId || '' : '';
});

watch(
  () => route.pathname,
  () => {
    if (
      typeof sessionStorage === 'object' &&
      sessionStorage.getItem(MY_PAGES.AUTO_OPEN_KEY)
    ) {
      sessionStorage.removeItem(MY_PAGES.AUTO_OPEN_KEY);
      nextTick(() => {
        isMyPagesOpen.value = true;
      });
    } else {
      isMyPagesOpen.value = false;
    }
  }
);

async function onPageNavigate(pageItem: string) {
  if (pageItem == 'personReviews') {
    close();
    await navigate(reviewerPageUrl.value);
  }
}

function onMenuNavigate(menuItem: string) {
  if (user.value?.isAuthenticated) {
    selectedMenuItem.value = menuItem;
  } else {
    navigateToLoginPage(getMyPagesQuery());
  }
}

function showMenuItem(menuItem: string) {
  return selectedMenuItem.value === menuItem;
}

function onMenuBack() {
  selectedMenuItem.value = '';
}

async function openMyPages() {
  if (user.value?.isAuthenticated) {
    selectedMenuItem.value = '';
    isMyPagesOpen.value = true;
  } else {
    navigateToLoginPage(getMyPagesQuery());
  }
}

function getMyPagesQuery() {
  const search = route.query || {};
  const query = {
    ...search,
    action: 'my-pages',
  };
  return query;
}

function openMyOrders() {
  onMenuNavigate('orders');
}

function close() {
  isMyPagesOpen.value = false;
}

useEmitterEventListener('openMyPages', openMyPages);
useEmitterEventListener('openMyPages:orders', openMyOrders);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(DrawerLayer), {
      modelValue: isMyPagesOpen.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isMyPagesOpen).value = $event)),
      showCloseIcon: true,
      containerClass: "my-pages__modal-container"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (showMenuItem(''))
            ? (_openBlock(), _createBlock(MyPagesMenu, {
                key: 0,
                onNavigateMenu: onMenuNavigate,
                onNavigatePage: onPageNavigate,
                onClose: close
              }))
            : _createCommentVNode("", true),
          (showMenuItem('orders'))
            ? (_openBlock(), _createBlock(MyPagesOrders, {
                key: 1,
                onBack: onMenuBack,
                onCloseModal: _cache[0] || (_cache[0] = ($event: any) => (close()))
              }))
            : _createCommentVNode("", true),
          (showMenuItem('my-rentals'))
            ? (_openBlock(), _createBlock(MyPagesRentals, {
                key: 2,
                onBack: onMenuBack,
                onCloseModal: _cache[1] || (_cache[1] = ($event: any) => (close()))
              }))
            : _createCommentVNode("", true),
          (showMenuItem('personProfile'))
            ? (_openBlock(), _createBlock(PersonProfile, {
                key: 3,
                onBack: onMenuBack,
                onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (close()))
              }))
            : _createCommentVNode("", true),
          (showMenuItem('organizationProfile'))
            ? (_openBlock(), _createBlock(OrganizationProfile, {
                key: 4,
                onBack: onMenuBack,
                onCloseModal: _cache[3] || (_cache[3] = ($event: any) => (close()))
              }))
            : _createCommentVNode("", true),
          (showMenuItem('installer'))
            ? (_openBlock(), _createBlock(Installer, {
                key: 5,
                onBack: onMenuBack,
                onCloseModal: _cache[4] || (_cache[4] = ($event: any) => (close()))
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(AddressRemove)
  ], 64))
}
}

})